import { CompaniesComponent } from "./companies.component";
export var CompaniesModule = angular
    .module('companies', [])
    .component(CompaniesComponent.selector, CompaniesComponent.component)
    .name;
//# sourceMappingURL=companies.module.js.map